/**
 * BMC-Branding — single source of truth für die Chrome (Header/Login/UserMenu).
 *
 * Die Konsole ist in TP1 durchgängig BMC-gebrandet (Plattform-Betreiber, kein
 * per-Brand-White-Label). `logoLight` ist das normale/dunkle Logo für helle
 * Flächen, `logoDark` die weiße Variante für dunklen Grund (aus `public/`).
 */
export const brand = {
  name: 'Black Mountain Consult',
  product: 'vCard',
  /** dunkles/normales Logo — für hellen Hintergrund (Light-Theme). */
  logoLight: '/bmc-logo.png',
  /** weißes Logo (transparent) — für dunklen Hintergrund (Dark-Theme). */
  logoDark: '/bmc-logo-white.png',
} as const
